import React, { useState } from "react"
import PropTypes from "prop-types"
import YoutubeContainer from "./YoutubeContainer"
import LittleCards from "./LittleCards"

const Card = ({ data }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="m-4 p-4 bg-white shadow rounded">
      <div className="border rounded p-4 flex flex-col md:flex-row gap-4">
        <div className="flex flex-col items-center justify-center">
          <h2 className="text-xl font-bold mb-2">{data.title}</h2>
          {data.description && (
            <p className="mb-4 text-center">{data.description}</p>
          )}
          {data.advantages && (
            <ul className="mb-4 text-center">
              <LittleCards items={data.advantages} />
              {/* {data.advantages.map((advantage, index) => (
                <li key={index}>{advantage}</li>
              ))} */}
            </ul>
          )}
          {data.cite &&
            data.cite.map((item, index) => {
              return (
                <p className="italic text-sm text-gray-500" key={index}>
                  Cite:{" "}
                  <a href={item.href} target="_blank" rel="noopener noreferrer">
                    {item.title}
                  </a>
                  , {item.source}
                </p>
              )
            })}
        </div>
        {data.imageUrl && (
          <img
            src={data.imageUrl}
            alt=""
            className="w-full max-w-xs object-cover mb-4 rounded"
          />
        )}
      </div>
      <button
        className="text-blue-600 hover:text-blue-800 flex items-center"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? "Show less" : "Show more"}
      </button>
      {isExpanded && data.youtubeLink && (
        <YoutubeContainer youtubeLink={data.youtubeLink} />
      )}
    </div>
  )
}

Card.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    cite: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        source: PropTypes.string,
        href: PropTypes.string,
      }),
    ),
    imageUrl: PropTypes.string,
    advantages: PropTypes.arrayOf(PropTypes.string),
    youtubeLink: PropTypes.string,
  }),
}

Card.defaultProps = {
  data: {
    title: "Sample Strategy",
    description: "This is a description of the sample strategy.",
    cite: [],
    imageUrl: "https://via.placeholder.com/150",
    advantages: ["Advantage 1", "Advantage 2", "Advantage 3"],
    youtubeLink: "dQw4w9WgXcQ", // This is a sample YouTube video ID. Please replace with your actual YouTube video ID.
  },
}

export default Card
